<template lang="html">
  <ns-loader
        class="ns-loader"
        :toLoad="toLoad"
        @dataFetched="onDataFetched"
    >
    <div class="resultats" ref="mainContainer" slot="content">
        <top-nav></top-nav>
        <el-dialog
            :title="getText('simulation_archiving_title')"
            :visible.sync="archivingSimulation"
            class="archivingDialog"
            width="30%"
        >
            <p>{{getText('simulation_archiving_warning')}}</p>
            <span slot="footer">
                <el-button
                    class="whiteButton"
                    @click="closeArchiveModal"
                >{{getText('cancel_button')}}</el-button>
                <el-button
                    class="greenButton"
                    v-loading="loadingState"
                    type="primary"
                    @click="archive(simulation)"
                >{{getText('simulation_archive_button')}}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            v-if="simulation"
            :visible.sync="alertModalIsOpened"
            width="70%"
            class="alert-modal"
        >
            <div slot="title">
                <p class="modal-title"><i class="el-icon-warning warning-icon"></i>{{ simulation.alerts_data.length }} {{ simulation.alerts_data.length > 1 ? getText('simulation_alert_modal_title_multiple') : getText('simulation_alert_modal_title_single') }}</p>
            </div>
            <div>
                <el-row
                    v-for="(alert, index) in simulation.alerts_data"
                    :key="index"
                    :gutter="20"
                >
                    <el-col :span="8">
                        <p class="alert-title">{{alert.short_description[getLangage]}}</p>
                    </el-col>
                    <el-col :span="16">
                        <vue-markdown class="alert-desc" :source="alert.long_description[getLangage]"></vue-markdown>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer">
                <el-button @click="alertModalIsOpened = false">{{getText('close_button')}}</el-button>
            </span>
        </el-dialog>
        <div class="page-title">
            <div class="title-container">
                <el-row :gutter="24" type="flex" justify="space-between">
                    <el-col
                        :xs="6"
                        :sm="10"
                        :md="10"
                        :lg="6"
                        :xl="6"
                    >
                        <span class="icon icon-reports"></span>
                        <h1>{{getText('simulation_title')}}</h1>
                    </el-col>
                    <el-col
                        :xs="{span: 18, offset: 0}"
                        :sm="{span: 14, offset: 0}"
                        :md="{span: 12, offset: 2}"
                        :lg="{span: 16, offset: 2}"
                        :xl="{span: 14, offset: 4}"
                    >
                        <div class="delete-button-container" v-if="simulation && simulation.status != 'ARCHIVED'">
                            <el-button class="whiteButton archive" @click="toggleSimulationArchivingModal">{{getText('simulation_archive_button')}}</el-button>
                        </div>
                        <router-link
                            :to="{ name: 'moteurs', params: { siteid: simulationEngine.factory_uid } }"
                        >
                            <el-button class="whiteButton">{{getText('motors_audit_report_title')}}</el-button>
                        </router-link>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="viveco-footer-background selection topdf">
            <div v-if="simulation && simulation.warning" class="alert-button-container">
                <el-alert
                    v-if="simulation.alerts_data.length === 0 || Object.keys(simulation.alerts_data).length === 0"
                    :closable="false"
                    :title="getText('simulation_warning')"
                    type="warning"
                    effect="dark"
                    class="simulation-warning"
                ></el-alert>
                <el-button v-else type="warning" @click="alertModalIsOpened = true">{{getText('simulation_alert_modal_opening_button')}}</el-button>
            </div>
<!--             <page-subtitle v-if="simulationAvailable" :title="simulation.name" icon="reports"></page-subtitle>
 -->            <div class="header-container">
                <div class="info">
                    <page-subtitle v-if="simulationAvailable" :title="simulation.name" icon="reports"></page-subtitle>
                    <span class="simulationTableInfo">{{getText('simulation_table_information')}}</span>
                </div>
                <el-table v-if="simulation && simulation.report_context.bilan_energy && simulation.report_context.bilan_euros" class="table-report" :data="dataForReport">
                    <el-table-column :label="getText('simulation_report_title')">
                        <el-table-column
                            prop="audit"
                            :label="getText('simulation_report_audit')"
                            width="150"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="year"
                            :label="getText('simulation_report_year')"
                            width="150"
                        >
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="simulationLoaded">
                <div>
                    <table-component
                        class="resultTable"
                        id="test"
                        :data="simulationResults"
                        :show-filter="false"
                        :show-caption="false"
                        sort-by="earningMwh"
                        sort-order="desc"
                    >
                        <table-column show="engineClass" :label="getText('simulation_tab_solution')"></table-column>
                        <table-column
                            show="earningMwh"
                            :label="getText('simulation_tab_gain_energy')"
                            data-type="numeric"
                        ></table-column>
                        <table-column
                            show="earningPercent"
                            :label="getText('simulation_tab_gain_percent')"
                            data-type="numeric"
                        ></table-column>
                        <table-column
                            show="earningMoney"
                            :label="getText('simulation_tab_gain_money')"
                            data-type="numeric"
                        ></table-column>
                        <table-column
                            :label="getText('simulation_tab_cost')"
                            :sortable="false"
                            show="cost"
                        >
                        </table-column>
                        <table-column
                            :label="getText('simulation_tab_ROI')"
                            data-type="numeric"
                        >
                            <template slot-scope="row">
                                <span :class="{'outOfInterest': isROINotUsable(row.roiExpression)}">{{row.roiExpression}}</span>
                            </template>
                        </table-column>
                    </table-component>
                    <simulation-overrides
                        :simulation="simulation"
                    >
                    </simulation-overrides>
                </div>
            </div>
            <div v-else class="empty">
                <h1 v-if="this.simulation && this.simulation.status=='FAILED'" class="empty">{{getText('simulation_dataless')}}</h1>
                <h1 v-else-if="simulationIsUsable === false" class="empty">{{getText('simulation_error_NaN_Inf')}}</h1>

                <h1 v-else class="empty">{{getText('simulation_data_computing')}}</h1>
            </div>
            <div class="download-buttons-container">
                <div v-if="simulation != null && simulationResults.length">
                    <el-button v-loading="xlsxLoader" class="whiteButton" @click="xlsxDownload">
                        <svg-button></svg-button>
                        {{getText('simulation_button')}}
                    </el-button>
                </div>
                <div v-if="simulation">
                    <docx-download-button
                        :uid="simulation.report_expert_uid"
                        docType="expert_report"
                    ></docx-download-button>
                </div>
                <div v-if="simulation">
                    <docx-download-button
                        :uid="simulation.report_client_uid"
                        docType="client_report"
                    ></docx-download-button>
                </div>
            </div>
            <div class="button">
                <cancel-back :txt="getText('previous_button')"></cancel-back>
                <el-button v-if="simulationIsUsable" v-loading="paDataLoader" class="dataButton greenButton right" @click="getPaData()">{{getText('simulation_view_data')}}</el-button>
            </div>
            <br><br>
            <br><br>
            <br><br>
            <br><br>
            <el-dialog
                :visible.sync="simulationDialog"
                :title="getText('simulation_chart_dialog_title')"
                id="ignorePDF"
                class="simulation-chart-dialog"
            >
                <div v-if="simulation" class="dialog-stats">
                    <el-row :gutter="24" type="flex" align="middle" style="flex-wrap: wrap;">
                        <el-col :xs="24" :sm="24" :md="14" :lg="12" :xl="8">
                            <div class="pie-chart">
                                <div id="graph"></div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="10" :lg="12" :xl="16">
                            <el-row :gutter="0" class="informations" type="flex" align="top" justify="start" style="flex-wrap: wrap; text-align: left;">
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                                    <span class="title">{{getText('simulation_chart_minimum_value')}}</span><span class="number"><strong>{{simulation.report_context.pe_min.toFixed(2)}} kW</strong></span>
                                </el-col>
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="16" >
                                    <span class="title">{{getText('simulation_chart_maximum_value')}}</span><span class="number"><strong>{{simulation.report_context.pe_max.toFixed(2)}} kW</strong></span>
                                </el-col>
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                                    <span class="title">{{getText('simulation_chart_average_value_electric')}}</span><span class="number"><strong>{{ simulation.report_context.pe_moy.toFixed(2) }} kW</strong></span>
                                </el-col>
                            </el-row>
                            <el-row :gutter="0" class="informations" type="flex" align="top" justify="start" style="flex-wrap: wrap; text-align: left;">
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                                    <span class="title">{{getText('simulation_chart_average_value')}}</span><span class="number"><strong>{{simulation.report_context.pm_moy.toFixed(2)}} kW</strong></span>
                                </el-col>
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="16">
                                    <span class="title">{{getText('simulation_chart_ratio')}}</span><span class="number"><strong>{{getRatio}} %</strong></span>
                                </el-col>
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                                    <span class="title">{{getText('simulation_chart_number_of_start')}}</span><span class="number"><strong>{{simulation.report_context.nb_starts || 0}}</strong></span>
                                </el-col>
                                <el-col class="data" :xs="24" :sm="24" :md="24" :lg="12" :xl="16">
                                    <span class="title">{{getText('simulation_chart_theoretical_efficiency')}}</span>
                                    <span class="number" :class="{'warning': getTheoreticalEfficiency > 1}"><strong>{{ getTheoreticalEfficiency }}</strong></span>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :offset="18" :span="6">
                            <el-button type="text" class="reportButton" @click="openSecondDialog">{{getText('simulation_view_daily_stats')}}</el-button>
                        </el-col>
                    </el-row>
                    <hr class="line">
                    <el-row :gutter="24" type="flex" align="middle" class="pa-chart-container" v-loading="csvData.length === 0" :element-loading-text="getText('global_user_information_latency')">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <simulation-chart
                                :key="`${keyGeneratedForChildRendering}`"
                                :paData="csvData"
                                :start="simulation.start_date"
                                :end="simulation.end_date"
                            ></simulation-chart>
                        </el-col>
                    </el-row>
                </div>


                <div class="buttons">
                    <el-button class="whiteButton closeButton" @click="closeDialog()">{{getText('close_button')}}</el-button>
                </div>
            </el-dialog>
            <el-dialog
                :title="getText('simulation_view_daily_stats')"
                :visible.sync="secondDialog"
                @close="closeSecondDialog">
                <el-row :gutter="24" type="flex" align="middle" class="daily-chart-container">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <daily-chart
                            v-if="simulation"
                            :dataStat="simulation.report_context.stat_graph"
                        ></daily-chart>
                    </el-col>
                </el-row>
                <div class="buttons">
                    <el-button class="whiteButton closeButton" @click="closeSecondDialog()">{{getText('close_button')}}</el-button>
                </div>
            </el-dialog>
        </div>
        <page-footer></page-footer>
    </div>
  </ns-loader>
</template>

<script>
import {dsvFormat, text} from 'd3';
import moment from 'moment';
import Plotly from 'plotly.js-basic-dist';
import {mapGetters} from 'vuex';

import VueMarkdown from 'vue-markdown';
import dailyChart from './simulationDailyChart.vue';
import topNav from '../ui/top-nav.vue';
import pageTitle from '../ui/page-title.vue';
import pageSubtitle from '../ui/page-subtitle.vue';
import pageFooter from '../ui/page-footer.vue';
import cancelBack from '../ui/cancel-back.vue';
import simulationChart from './simulationChart.vue';
import axios from 'axios';
import simulationOverrides from './simulationOverrides.vue';
import humanizeNumber from 'humanize-number';
import svgButton from './simulation/svgButton.vue';
import docxDownloadButton from './simulation/docxDownloadButton.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';

export default {
    data() {
        return {
            alertModalIsOpened: false,
            simulation: null,
            report_client: null,
            report_expert: null,
            keyGeneratedForChildRendering: 0,
            xlsxLoader: false,
            paDataLoader: false,
            loadingState: false,
            csvData: [],
            formData: null,
            simulationDialog: false,
            secondDialog: false,
            simulationContent: '',
            pieOptions: {
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: false
                }
            },
            //simulationEngine: {},
            simulationIsUsable: true,
            archivingSimulation: false,
        };
    },
    components: {
        VueMarkdown,
        topNav,
        pageTitle,
        pageSubtitle,
        pageFooter,
        cancelBack,
        simulationChart,
        simulationOverrides,
        dailyChart,
        svgButton,
        docxDownloadButton,
        NsLoader
    },
    updated() {
        if (this.simulationDialog && this.simulation) {

            let data = [{
                values: [
                    this.simulation.report_context.pm_0_2 * 100,
                    this.simulation.report_context.pm_2_25 * 100,
                    this.simulation.report_context.pm_25_50 * 100,
                    this.simulation.report_context.pm_50_75 * 100,
                    this.simulation.report_context.pm_75_100 * 100,
                ],
                labels: [
                    this.getText('simulation_time_0_2'),
                    this.getText('simulation_time_2_25'),
                    this.getText('simulation_time_25_50'),
                    this.getText('simulation_time_50_75'),
                    this.getText('simulation_time_75_100'),
                ],
                hoverinfo: 'label',
                marker: {
                    colors: ['#C1BEAC', '#6091ED', '#33C842', '#E58A18', '#E9C102']
                },
                type: 'pie'
            }];


            let layout = {
                height: 400,
                width: 500
            };


            Plotly.newPlot('graph', data, layout);
        }
    },
    computed: {
        ...mapGetters([
            'getText',
            'getLangage',
            'factoryEnginesByUid',
        ]),
        toLoad() {
            if (this.$route.params.uid === null) {
                return [];
            }
            return [
                {
                    model: 'simulations',
                    name: 'simulation',
                    uid: this.$route.params.uid
                }
            ]
        },
        simulationEngine(){
            if(this.simulation && this.simulation.motor_uid){
                return this.factoryEnginesByUid(this.simulation.motor_uid);
            }
            return {}
        },
        dataForReport() {
            return [
                {
                    audit: this.simulation.report_context.bilan_energy.audit,
                    year: this.simulation.report_context.bilan_energy.year,
                },
                {
                    audit: this.simulation.report_context.bilan_euros.audit,
                    year: this.simulation.report_context.bilan_euros.year
                }
            ];
        },
        getRatio() {
            if(this.simulationEngine.nominal_power > 0){
                return ((this.simulation.report_context.pm_max / this.simulationEngine.nominal_power) * 100).toFixed(0);
            }
            return 0;
        },

        getTheoreticalEfficiency (){
            return this.simulation.report_context.eff_nom.toFixed(4);
            // let motor = this.simulation.motor;
            // if(motor){
            //     return (motor.nominal_power / (Math.sqrt(3) * motor.nominal_voltage * motor.nominal_current * motor.cos_phi / 1000)).toFixed(4);
            // }
            // return this.getText('new_simulation_dialog_step_two_empty');
        },
        // simulation(){
        //     return this.simulationsByUid(this.$route.params.uid);
        // },
        simulationAvailable() {
            return this.simulation != null;
        },
        lang(){
            return this.getLangage;
        },
        simulationResults(){
            if (!this.simulation) {
                return [];
            }
            this.checkSimulation();
            if (this.simulationIsUsable === false) {
                return [];
            }
            let mappedSimulations = this.simulation.gains_kwh.map((gain, index) => {
                let hasVariator = gain.has_variator;
                let switchMotor = gain.switch_motor;
                let gainMwh = gain.gain_kwh / 1000;
                let gainPercent = this.simulation.gains_percent[index].gain_percent;
                let gainEuros = this.simulation.gains_euros[index].gain_euros;
                let option = hasVariator && switchMotor !== 'current' ? this.getMotorClassTranslation('+ variator'): '';
                let cost = this.simulation.costs[index].cost;
                let roi = this.simulation.times_before_benefit[index].time_before_benefit;
                if (roi >= 0 &&  roi <= 20) {
                    roi = `${moment.duration(roi, 'years').humanize()} (${roi.toFixed(1)} ${this.getText('years')})`;
                }
                else if (roi < 0) {
                    roi = this.getText('simulation_negative_roi');
                }
                else if (roi > 20) {
                    roi = this.getText('simulation_roi_higer_than_20');
                }
                return {
                    uid: this.simulation.name,
                    earningPercent: `${gainPercent.toFixed(2)} %`,
                    engineClass: `${this.getMotorClassTranslation(switchMotor)} ${option}`,
                    earningMwh: `${humanizeNumber(gainMwh.toFixed(2), {delimiter: ' ', separator: '.'})} MWh`,
                    earningMoney: `${humanizeNumber(gainEuros.toFixed(2), {delimiter: ' ', separator: '.'})} €`,
                    cost: `${humanizeNumber(cost, {delimiter: ' ', separator: '.'})} €`,
                    roiExpression: roi,
                    selectReport: true
                };
            });
            let filteredSimulations = mappedSimulations.filter(simulation => {
                return simulation.roiExpression != this.getText('simulation_negative_roi') && simulation.roiExpression != this.getText('simulation_roi_higer_than_20');
            });
            if (filteredSimulations.length === 0) {
                filteredSimulations.push({empty: true});
            }
            return filteredSimulations;
        },
        simulationLoaded () {
            return this.simulationResults.length > 0;
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.keyGeneratedForChildRendering = window.innerWidth.toString()+this.getLangage;
            });
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.keyGeneratedForChildRendering = window.innerWidth+this.getLangage;
        });
    },
    watch: {
        getLangage() {
            this.keyGeneratedForChildRendering = window.innerWidth+this.getLangage;
        }
    },
    methods: {
        onDataFetched(data) {
            if (data.simulation) {
                this.simulation = data.simulation;
            }
        },
        openSecondDialog() {
            this.$refs.mainContainer.style.overflow = 'hidden';
            this.secondDialog = true;
        },
        closeSecondDialog() {
            this.secondDialog = false;
            this.$refs.mainContainer.style.overflow = '';
        },
        closeArchiveModal() {
            this.loadingState = false;
            this.archivingSimulation = false;
        },
        toggleSimulationArchivingModal() {
            this.archivingSimulation = true;
        },
        checkSimulation() {
            if (!this.simulation) {
                return false;
            }
            this.simulation.gains_kwh.forEach((gain, index) => {
                if (!gain) {
                    this.$set(this, 'simulationIsUsable', false);
                }
                if (isNaN(this.simulation.gains_percent[index].gain_percent)) {
                    this.$set(this, 'simulationIsUsable', false);
                }
                if (this.simulation.times_before_benefit[index].time_before_benefit === 'inf') {
                    this.$set(this, 'simulationIsUsable', false);
                }
            });
        },

        getPaData() {
            this.paDataLoader = true;
            this.openDialog();
            let psv = dsvFormat(',');
            this.csvData = [];
            text(this.simulation.pa_graph_file).then(text => {
                let parsedData = psv.parse(text);
                let keys = Object.keys(parsedData[0]);

                parsedData.forEach(obj => {
                    let item = {};
                    keys.forEach(key => {
                        item[key] = obj[key];
                    });
                    this.csvData.push(item);
                });
                this.paDataLoader = false;
                this.waitingForStatsData = false;
                this.openDialog();
            });
        },
        isROINotUsable(roi) {
            return roi == this.getText('simulation_negative_roi') || roi == this.getText('simulation_roi_higer_than_20');
        },
        logClient() {
            return this.simulation && this.simulation.log_client ? this.$store.state.simulation_error[this.simulation.log_client][this.getLangage] : '';
        },
        archive () {
            this.loadingState = true;
            this.$store.axios.patch(
                `${window.config.api_root_url}/simulation/${this.$route.params.uid}/`,
                {archived: true},
            ).then(response => {
                let itemData = {modelName: 'simulations', item: response.data};
                this.$store.commit('EDIT_ITEM', itemData);
                this.loadingState = false;
                this.$router.push({ name: 'simulations' });
            }).catch(error => {
                this.loadingState = false;
                this.$notify.error({
                    title: 'Error',
                    message: 'Error while archiving the simulation.',
                });
            });
        },
        xlsxDownload() {
            this.xlsxLoader = true;
            let url = this.simulation.xlsx_simulation;
            axios({
                method: 'GET',
                url: url,
                responseType: 'blob'
            }).then((response) => {
                let url = window.URL.createObjectURL(new Blob([response.data]));
                let link = document.createElement('a');
                link.style = 'display: none';
                link.href = url;

                link.download = `export-${moment().format('YYYY-MM-DD-HH-mm')}.xlsx`;
                document.body.appendChild(link); // Required for FF
                link.click(); // This will download the data file named "my_data.csv".

                this.xlsxLoader = false;
                this.$notify.success({
                    message: this.getText('simulation_report_success')
                });
            }).catch(error => {
                console.error(error);
                this.$notify({
                    type: 'error',
                    message: this.getText('simulation_report_error')
                });
                this.xlsxLoader = false;
            });

        },
        getMotorClassTranslation(opt) {
            return this.$store.state.trad[opt] ? this.$store.state.trad[opt][this.getLangage] : `${this.$store.state.trad['installation'][this.getLangage]} ${opt.toUpperCase()}`;
        },
        openDialog() {
            this.simulationDialog = true;
        },
        closeDialog() {
            this.simulationDialog = false;
        },
    }
};
</script>

<style lang="less">
@import '../../less/variables';
.alert-modal {
    font-size: 24px;
    word-break: break-word;
    .modal-title {
        font-size: 30px;
        text-align: center;
        .warning-icon {
            color: #E6A23C;
            margin-right: 20px;
        }
    }
    .alert-title {
        text-align: left;
        font-weight: bold
    }
    .alert-desc {
        text-align: left;
    }
}
.resultats {
    .simulation-chart-dialog {
        .buttons {
            margin-bottom: 0;
        }
    }
    .el-dialog {
        width: 90%;
        padding-bottom: 0;
        .el-dialog__header {
            width: 97%;
        }
        .el-dialog__title {
            font-size: 24px;
            margin: 0;
        }
        .chartTitle {
            font-size: 24px;
            margin: 30px 0 0 0;
        }
        .line {
            width: 98%;
        }
    }

    .waiting-for-stats-data {
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            padding-top: 0;
            padding-bottom: 0;
            p {
                margin-top: 0;
            }
        }
        .el-dialog__footer {
            // display: none;
            padding-top: 0;
            padding-bottom: 5px;
        }
    }
    .archivingDialog {
        .el-dialog__title {
            margin-left: 0;
            font-size: 24px;
        }
        .el-dialog__body {
            text-align: left !important;
            padding-left: 40px;
        }
        .el-dialog__header {
            width: 90%;
        }

    }
    .cancelButton {
        float: left;
        margin-left: 60px !important;
    }
    .dataButton {
        margin-right: 60px !important;
    }
    .page-title-cta  {
        padding-top: 10px;
    }
    .page-title-cta:first-child  {
        padding-top: 20px;
    }
    .page-title-cta:last-child  {
        padding-bottom: 20px;
    }
    .page-subtitle, .title-container {
        padding: 1em;
        margin-left: 60px;
    }
    .title-container {
        width: 80%;
        margin:auto;
        .delete-button-container {
            margin-bottom: 10px;
        }
    }
    .table-component table {
        width: 100%;
    }
    .el-row {
        align-items: center;
    }
    .download-buttons-container {
        margin-top: 40px;
        margin-left: 5%;
        margin-bottom: 0;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        .whiteButton, .failedButton, .disabledButton {
            margin-right: 10px;
            margin-bottom: 10px;
        }

        .report-error {
            color: white;
            font-size: 18px;
            width: 350px;
            font-weight: 400;
            margin-top: 10px;
        }
    }
}
.dialog-stats {
    width: auto;
    .reportButton, .dataButton {
        border: none;
        text-transform: uppercase;
        font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
        font-size: 18px;
        line-height: 18px;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 3px 1px -2px;
        padding: 15px 30px 10px;
        background: #c4d600;
        color: white;
        margin: -30px 0 20px 50px;
    }
    .pa-chart-container {
        margin-bottom: 30px;
        .el-loading-mask {
            .el-loading-text {
                color: @color-1;
            }
        }
    }
    .number.warning{
        color: red;
    }
    .pie-title {
        margin-bottom: 30px;
    }
    .stat-title {
        display: block;
        width: 100%;
        text-align: center;
    }
    .informations {
        line-height: 35px;
        font-size: 18px;
        .data {
            margin-bottom: 40px;
            .title {
                margin-right: 20px !important;
                font-family: "Montserrat";
                display: block;
                word-break: break-word;
            }
        }
    }
}
.closeButton {
    width: 25%;
}
.el-tabs__item.is-active {
    color: @color-1;
}
.el-tabs__item:hover {
    color: @color-1;
}
.viveco-footer-background.selection {
    .alert-button-container {
        margin: 20px 60px;
    }
    .simulation-warning {
        margin: 20px 20%;
        width: 60%;
        margin-left: 20%;
        margin-bottom: 20px;
    }
    .header-container {
        display: flex;
        width: 100%;
        .info {
            text-align: left;
            width: 60%;
            .page-subtitle {
                padding: 20px 0 20px;
            }
        }
        .table-report {
            width: 301px;
            max-width: 301px;
            .el-table__header-wrapper {
                .el-table__header {
                    tr, th {
                        text-align: center;
                        background-color: @color-1;
                    }
                }
                .cell {
                    color: white
                }
            }
            tbody {
                tr:hover>td {
                    background-color: white;
                }
            }
        }
    }
    .noSimulationUsable, .simulationTableInfo{
        display: block;
        margin-left: 74px;
    }
    .resultTable {
        margin-top: 20px;
    }
    .table-component tbody tr:nth-child(even) {
        background: rgba(51, 51, 51, 0.05);
    }
    .outOfInterest {
        font-style: italic;
    }
    .button {
        text-align: center;
        button {
            margin: 40px auto 40px auto;
        }
    }
}
.noReport {
    width: auto;
    p {
        margin: 0;
        text-align: center;
        border-radius: 4px;
    }
}
.empty {
    margin: 30px 0 0 80px;
    h1 {
        margin-left: 0;
    }
    button {
        margin: 40px 0;
    }
    .emptyDesc {
        color: @color-1;
        margin-left: 0;
        margin-top: 40px;
        font-size: 18px;
    }
}


.archive {
    margin-top: 10px;
}

.download {
    margin: -11px 12px 0 -12px;
    width: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/simulation.vue